import React from "react";
import StarRating from "./StarRating";
import ProductReview from "./ProductReview";

const ProductReviews = ({ reviewData }) => {
  return (
    <>
      {reviewData && (
        <div className="border-b border-gray-lightest my-10">
          <StarRating
            rating={reviewData.bottomline.averageScore}
            text={`Based on ${reviewData.bottomline.totalReview} review${
              reviewData.bottomline.totalReview > 1 ? "s" : ""
            }`}
            className="mb-8"
          />
        </div>
      )}
      {reviewData &&
        reviewData.reviews.map((review) => (
          <ProductReview
            name={review.user.displayName}
            date={review.createdAt}
            title={review.title}
            content={review.content}
            score={review.score}
            verifiedBuyer={review.verifiedBuyer}
          />
        ))}
    </>
  );
};

export default ProductReviews;
